import Carousel from 'bootstrap/js/dist/carousel'

// Styles
import '../../scss/components/homeCarousel'

document.querySelectorAll('.carouselHome').forEach(el => {
  const myCarousel = new Carousel(el, {
    interval: 3000
  })
  myCarousel.cycle()
})
